import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { trainOfferEvtTree } from "../../../Orchestrator/ConstantTree";
import { IAppliedPassengerPassAtomType } from "../../../Orchestrator/Recoils/BookingAtom";
import { getRecoilStateValue, updateRecoilState, updateRecoilStateWithType } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { SearchStateType } from "../../../Orchestrator/Types/Index";
import dayjs from 'dayjs';

export interface IMultiplePassengerPassApplyActionParams {
  passengerPasses: IAppliedPassengerPassAtomType
}

export class MultiplePassengerPassApplyAction extends BaseAction<void, IMultiplePassengerPassApplyActionParams> {
  override async run(): Promise<void> {
    const { passengerPasses } = this.params!;

    if (passengerPasses) {
      const searchState = getRecoilStateValue<SearchStateType>("searchStateAtom")
      const currentTrainType = getRecoilStateValue<TrainTypeEnum>("trainTypeAtom");

      updateRecoilStateWithType("appliedPassengerPassAtom", passengerPasses)

      const data = currentTrainType === TrainTypeEnum.inbound ? searchState?.inboundDate : searchState?.outboundDate;
      _eventBus.emit({
        eventName: trainOfferEvtTree.Offer.DateSelector.Change,
        data: {
          fullDate: dayjs(data).toISOString(),
          currentTrainType: currentTrainType,
          search: searchState,
        },
      });

      // Reset selected train and related states
      if (currentTrainType === TrainTypeEnum.outbound) {
        updateRecoilState("selectedOutboundTrainAtom", null);
        updateRecoilState("originalTrainClassSelectionAtom", null);
      } else {
        updateRecoilState("selectedInboundTrainAtom", null);
        updateRecoilState("originalTrainClassSelectionAtom", null);
      }
      updateRecoilState("selectedOfferIdAtom", null);
      updateRecoilState("ticketTypeStateAtom", null);
    }
  }
}

export const multiplePassengerPassApplyAction = new MultiplePassengerPassApplyAction();
